import React, { useState } from 'react';
import Navigation from './navigation';

const NavButton = () => {
    const [show, setShow] = useState(false);

    const Show = () => {
        setShow(!show);
        console.log(show);
    }

    return (<div className="nav-button-position">
        {show ? <button className="small-nav" onClick={() => Show()}><Navigation /></button> : ""}
        {show ? "" : <button onClick={() => Show()} className="nav-button">	&#9776;</button>}
    </div>)
}

export default NavButton;